export default __webpack_public_path__ + "static/timeline-mask-e174f87f0b9d1ef094a2945ca622f341.svg";